import {Routes} from '@angular/router';
import {ResultsComponent} from './results/results.component';

export const recommendationRoutesProtected: Routes = [{path: 'recommendation', component: ResultsComponent}];
